export default __webpack_public_path__ + "static/Sign-up-for-Singapores-free-city-bus-tour-67315f78082e0bec66d1a05e947c305c.jpg";